var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretUp = function SvgCaretUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m8.594 6.216 5.16 4.526a.675.675 0 0 1 0 1.042.926.926 0 0 1-1.189 0L8 7.78l-4.565 4.005a.926.926 0 0 1-1.189 0 .675.675 0 0 1 0-1.042l5.16-4.526A.9.9 0 0 1 8 6a.9.9 0 0 1 .594.216"
  })));
};
export default SvgCaretUp;